import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6f64f549"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "left-warp"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = ["element-loading-background"];
const _hoisted_6 = {
  class: "collapse-list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "amount"
};
const _hoisted_10 = {
  class: "info-warp"
};
const _hoisted_11 = {
  class: "check-warp"
};
const _hoisted_12 = ["checked", "onChange"];
const _hoisted_13 = {
  key: 1
};
import MoviesOrActorItem from './moviesOrActorItem.vue';
import { inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { messageBox } from '@/utils/validate';
import { getPlayHistoryInfoApi, getFavoritesListApi, savePlayHistoryInfoApi } from '@/api/vodPlus';
import moment from 'moment';
import { ElMessageBox } from 'element-plus';
import { elMessage } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'historyOrCollection',
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const currentParams = inject('currentParams');
    const currentActive = ref('history');
    const leftWarpList = ref([{
      name: t('history'),
      value: 'history',
      icon: require('../../images/otherStyle/home_icon_history.png')
    }, {
      name: t('collection'),
      value: 'collection',
      icon: require('../../images/otherStyle/home_icon_favorite.png')
    }]);
    const rightWarpList = ref([]);
    const showCheckBox = ref(false);

    const isCheck = item => {
      if (currentActive.value == 'history') {
        const {
          delId
        } = item;
        return checkSelectList.value.indexOf(delId) > -1 ? true : false;
      } else {
        const {
          id
        } = item;
        return checkSelectList.value.indexOf(id) > -1 ? true : false;
      }
    };

    const checkSelectList = ref([]);

    const handleCheckChange = (val, item) => {
      if (currentActive.value == 'history') {
        const {
          delId
        } = item;
        const idx = checkSelectList.value.indexOf(delId);

        if (idx == -1) {
          checkSelectList.value.push(delId);
        } else {
          checkSelectList.value.splice(idx, 1);
        }
      } else {
        const {
          id
        } = item;
        const idx = checkSelectList.value.indexOf(id);

        if (idx == -1) {
          checkSelectList.value.push(id);
        } else {
          checkSelectList.value.splice(idx, 1);
        }
      } // console.log('checkSelectList', checkSelectList.value);

    };

    onMounted(() => {
      console.log('currentParams', currentParams.value);

      if (currentParams.value) {
        currentActive.value = currentParams.value.value;
        getRightList(currentActive.value);
      } // getData()

    });

    const handleLeftWarpItemClick = item => {
      console.log(item);
      showCheckBox.value = false;
      checkSelectList.value = [];
      rightWarpList.value = [];
      currentActive.value = item.value;
      getRightList(item.value);
    };

    const handleOk = async () => {
      console.log('checkSelectList.value', checkSelectList.value);
      const allRightListArr = [];
      const messageBoxTest = [];
      rightWarpList.value.forEach(item => {
        item.programlist && allRightListArr.push(...item.programlist);
      });
      allRightListArr.forEach((arrItem, arrIndex) => {
        let idx;

        if (currentActive.value == 'history') {
          idx = checkSelectList.value.indexOf(arrItem.delId);
        } else {
          idx = checkSelectList.value.indexOf(arrItem.id);
        }

        if (idx > -1) {
          // console.log(arrItem.id);
          messageBoxTest.push(arrItem.name);
        }
      });
      return ElMessageBox.confirm(t('是否删除历史或收藏', {
        list: messageBoxTest.join(',')
      }), t('Warning'), {
        confirmButtonText: t('是的，确定'),
        cancelButtonText: t('不，取消'),
        type: 'warning',
        closeOnClickModal: false
      }).then(async () => {
        if (currentActive.value == 'history') {
          try {
            let params = {
              action: 1,
              delId: checkSelectList.value.join(',')
            };
            const res = await savePlayHistoryInfoApi(params);

            if (res.status == 200) {
              elMessage('success', '删除成功');
              checkSelectList.value = [];
              getRightList(currentActive.value);
            }
          } catch (error) {}
        } else {
          getRightList(currentActive.value);
        }
      });
    };

    const handleDeleteAll = () => {
      messageBox('确认删除全部?').then(async () => {
        if (currentActive.value == 'history') {
          try {
            let params = {
              action: 2
            };
            const res = await savePlayHistoryInfoApi(params);

            if (res.status == 200) {
              elMessage('success', '删除成功');
              getRightList(currentActive.value);
            }
          } catch (error) {}
        } else {
          getRightList(currentActive.value);
        }
      });
    };

    const isLoading = ref(false);

    const getRightList = val => {
      checkSelectList.value = [];

      switch (val) {
        case 'history':
          getPlayHistoryInfo();
          break;

        case 'collection':
          getFavoritesList();
          break;

        default:
          break;
      }
    };

    const getPlayHistoryInfo = async () => {
      // return
      isLoading.value = true;

      try {
        const res = await getPlayHistoryInfoApi({});

        if (res.status == 200) {
          rightWarpList.value = formateHistoryRightData(res.data);
        }
      } catch (error) {}

      isLoading.value = false;
    };

    const getFavoritesList = async () => {
      return;
      isLoading.value = true;

      try {
        const res = await getFavoritesListApi({});
        console.log(res);

        if (res.status == 200) {
          rightWarpList.value = res.data.map((item, index) => {
            return { ...item,
              showInfoWarp: index == 0 ? true : false,
              titleClick: item => {
                item.showInfoWarp = !item.showInfoWarp;
              }
            };
          });
        }
      } catch (error) {}

      isLoading.value = false;
    };

    const itemClick = item => {
      let params = { ...item,
        id: item.mediaId,
        name: item.mediaName,
        type: item.mediaType
      };
      emit('onCardClick', params);
    };

    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const DATENOW = moment(moment().format('YYYY-MM-DD')); // fixed just for testing, use moment();

    const TODAY = DATENOW.clone().startOf('day');
    const YESTERDAY = DATENOW.clone().subtract(1, 'days').startOf('day');
    const A_WEEK_OLD = DATENOW.clone().subtract(7, 'days').startOf('day');

    const isToday = momentDate => {
      return momentDate.isSame(TODAY, 'd');
    };

    const isYesterday = momentDate => {
      return momentDate.isSame(YESTERDAY, 'd');
    };

    const isWithinAWeek = momentDate => {
      return momentDate.isAfter(A_WEEK_OLD);
    };

    const isTwoWeeksOrMore = momentDate => {
      return !isWithinAWeek(momentDate);
    };

    const formateHistoryRightData = data => {
      // if (!data.length) return []
      try {
        let tempArr = [];
        data.sort((a, b) => {
          return moment(b.playTime).unix() - moment(a.playTime).unix();
        });
        data.find(item => {
          if (isToday(moment(item.playTime))) {
            // console.log('isTody', item.playTime);
            item.categoryname = t('今日');
          } else if (isYesterday(moment(item.playTime))) {
            // console.log('isYesterday', item.playTime);
            item.categoryname = t('昨天');
          } else if (isWithinAWeek(moment(item.playTime))) {
            // console.log('isWithinAWeek', item.playTime);
            item.categoryname = t('一周');
          } else if (isTwoWeeksOrMore(moment(item.playTime))) {
            // console.log('isTwoWeeksOrMore', item.playTime);
            item.categoryname = t('更早');
          }
        });
        let categoryNameArr = data.reduce((p, c) => {
          if (!p.includes(c.categoryname)) {
            p.push(c.categoryname);
          }

          return p;
        }, []);
        categoryNameArr.forEach((item, index) => {
          tempArr.push({
            categoryname: item,
            programlist: [],
            showInfoWarp: index == 0 ? true : false,
            titleClick: item => {
              item.showInfoWarp = !item.showInfoWarp;
            }
          });
        });
        data.forEach(item => {
          tempArr.forEach(t => {
            if (t.categoryname == item.categoryname) {
              t.programlist.push({ ...item,
                imageUrl: item.image,
                mediaName: item.name,
                mediaType: item.type
              });
            }
          });
        });
        console.log('tempArr', tempArr);
        return tempArr;
      } catch (error) {}
    };

    watch(() => currentActive.value, val => {}, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_empty = _resolveComponent("el-empty");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["history-or-collection", _unref(currentUiStyleOptions).class])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftWarpList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(["pointer", currentActive.value == item.value ? 'is-active' : '']),
          onClick: $event => handleLeftWarpItemClick(item)
        }, [_createElementVNode("img", {
          src: item.icon,
          alt: ""
        }, null, 8, _hoisted_3), _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1)], 10, _hoisted_2);
      }), 128))])]), _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "right-warp",
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [rightWarpList.value.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [!showCheckBox.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "cms-op-btn-non-focus delete",
          onClick: _cache[0] || (_cache[0] = $event => showCheckBox.value = true)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), showCheckBox.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "cms-op-btn-non-focus cancel",
          onClick: _cache[1] || (_cache[1] = $event => showCheckBox.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('取消')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), showCheckBox.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          disabled: !checkSelectList.value.length,
          class: "comfirm",
          type: "danger",
          onClick: handleOk
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true), showCheckBox.value && currentActive.value != 'collection' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          class: "delete-all",
          type: "danger",
          onClick: handleDeleteAll
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除全部')), 1)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightWarpList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "collapse-item",
          key: index
        }, [_createElementVNode("div", {
          class: "title pointer",
          onClick: $event => item.titleClick(item)
        }, [_createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.categoryname), 1)]), currentActive.value == 'collection' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [showCheckBox.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "",
          type: "danger",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除分类')), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_9, _toDisplayString(item.programlist.length), 1)])) : _createCommentVNode("", true)], 8, _hoisted_7), _withDirectives(_createElementVNode("div", _hoisted_10, [item.programlist.length ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          gutter: 10
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.programlist, (infoItem, infoIndex) => {
            return _openBlock(), _createBlock(_component_el_col, {
              class: "info-item",
              span: 4,
              key: infoIndex
            }, {
              default: _withCtx(() => [_createVNode(MoviesOrActorItem, {
                onClick: $event => itemClick(infoItem),
                poster: infoItem.imageUrl,
                "program-name": infoItem.mediaName,
                rating: infoItem.rating
              }, null, 8, ["onClick", "poster", "program-name", "rating"]), _createElementVNode("div", _hoisted_11, [_withDirectives(_createElementVNode("input", {
                class: "pointer",
                type: "checkbox",
                checked: isCheck(infoItem),
                onChange: val => handleCheckChange(val, infoItem)
              }, null, 40, _hoisted_12), [[_vShow, showCheckBox.value]])])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 2
        }, 1024)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_empty, {
          style: {
            "width": "100%"
          },
          "image-size": 50
        })]))], 512), [[_vShow, item.showInfoWarp]])]);
      }), 128))])])], 64)) : _createCommentVNode("", true), !rightWarpList.value.length && !isLoading.value ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        style: {
          "width": "100%",
          "height": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)], 8, _hoisted_5)), [[_directive_loading, isLoading.value]])], 2);
    };
  }

});